export default __webpack_public_path__ + "static/media/kwik_white_bg.4e9691f8.png";